module.exports = __webpack_public_path__ + "d8e2118d50192144d5675c87634f685a.png";